export * from './public_api';
export { _firebaseAppFactory as ɵa } from './firebase.app.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angularfire2/index.js
// module id = 9
// module chunks = 4